import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import NavigationM from "./NavigationM.jsx";
import HeroM from "./HeroM.jsx";
import OfferM from "./OfferM.jsx";
import AboutUsM from "./AboutUsM.jsx";
import ServicesM from "./ServicesM.jsx";
import WorkM from "./WorkM.jsx";
import FAQM from "./FAQM.jsx";
import ContactM from "./ContactM.jsx";
import FooterM from "./FooterM.jsx";


function Mechanic() {
  return <div>
      <NavigationM />
      <HeroM />
      <OfferM />
      <AboutUsM />
      <ServicesM />
      <WorkM />
      <FAQM />
      <ContactM />
      <FooterM />
    </div>;
}

export default Mechanic;
